// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linesHeaderStyles } from "@conklin/App/Components/Cart/LinesHeader";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, getSystemColor, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

linesHeaderStyles.wrapper = {
    css: css`
        display: grid;
        grid-column-gap: 10px;
        ${({ includeActions }: any) =>
            includeActions
                ? "grid-template-columns: 91px minmax(45px,1fr) minmax(0,176px) minmax(0,129px) minmax(0,176px) minmax(34px, 110px);"
                : "grid-template-columns: 91px minmax(45px,1fr) minmax(0,176px) minmax(0,129px) minmax(0,176px);"};

        ${xScreen("lte", "lg")} {
            ${({ includeActions }: any) =>
                includeActions
                    ? "grid-template-columns: 91px minmax(45px,1fr) minmax(0,148px) minmax(0,108px) minmax(0,148px) minmax(34px, 110px);"
                    : "grid-template-columns: 91px minmax(45px,1fr) minmax(0,148px) minmax(0,108px) minmax(0,148px);"};
        }

        grid-column-gap: 12px;
        grid-auto-flow: column;
        padding: 8px;
        color: ${color("common.white")};
        font-size: ${fontConfig.fontSize.small}px;
        line-height: ${fontConfig.lineHeight.small};
        font-weight: ${fontConfig.weight.bold};
        width: 100%;
        background: ${color("common.ui6")};
        @media print {
            color: ${getSystemColor("common.white")};
            background: ${color("common.ui6")};
        }
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

linesHeaderStyles.itemDescription = {
    css: css`
        grid-column: 1 / 3;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 5;
        }
    `,
};

linesHeaderStyles.inventory = {
    css: css`
        grid-column: 3 / 4;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
linesHeaderStyles.qty = {
    css: css`
        grid-column: 4 / 5;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

linesHeaderStyles.total = {
    css: css`
        grid-column: 5 / 6;
        text-align: right;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

linesHeaderStyles.mdScreenBorder = {
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            display: block;
            border-bottom: 1px solid ${color("common.border")};
        }
    `,
};
